import axios from "axios";
import { store } from "@/store/store";

const instance = axios.create({
  // baseURL: "https://d99b5f86fcb7.ngrok-free.app/api/v1",
  // baseURL: "https://g1bra-be-production-edfa.up.railway.app/api/v1"
  baseURL: "https://g1bra-be-mission-quiz.up.railway.app/api/v1"
});

//https://g1bra-be-production-d82e.up.railway.app/api/v1
//https://www.api-g1bra.benjaminalamu.work/api/v1
//https://ra-g1bra.herokuapp.com/api/v1
//http://localhost:4000/api/v1

instance.interceptors.request.use(
  (config, reqAuth) => {
    console.log(reqAuth);
    // do somethong here
    return config;
  },
  (error) => {
    console.log(error);
  }
);

class Api {
  static async get(url, requireAuth = false) {
    try {
      let config = {
        headers: {
          "x-access-token": `${store.state.token}`,
        },
      };
      console.log({ config });
      let response = requireAuth
        ? await instance.get(url, config)
        : await instance.get(url);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  }

  static async post(url, payload, requireAuth = false) {
    console.log(store.state);
    try {
      let config = {
        headers: {
          "x-access-token": `${store.state.token}`,
        },
      };
      console.log(config);
      let response = requireAuth
        ? await instance.post(url, payload, config)
        : await instance.post(url, payload);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  }

  static async put(url, payload = {}, requireAuth = false) {
    try {
      let config = {
        headers: {
          "x-access-token": `${store.state.token}`,
        },
      };
      let response = requireAuth
        ? await instance.put(url, payload, config)
        : await instance.put(url, payload);
      return response;
    } catch (error) {
      return error.response;
    }
  }

  static async delete(url, payload = {}, requireAuth = true) {
    try {
      let config = {
        headers: {
          "x-access-token": `${store.state.token}`,
        },
        data: payload,
      };
      let response = requireAuth
        ? await instance.delete(url, config)
        : await instance.delete(url, { data: payload });
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export default Api;
